export default "__VITE_ASSET__c1093111__"